<template>
  <section v-if="dataList" class="my-type-channel">
    <div class="wrap">
      <h4 class="my-type-tit">많이 본 채널</h4>
      <div v-if="dataList.length > 0">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(channel, index) in dataList" :key="index" class="component-list">
            <a @click.prevent="moveToPlayer(channel.channelid)" href="#">
              <div class="thumb">
                <img :src="url(channel.image)" alt=""/>
              </div>
              <strong>{{ channel.channelname }}</strong>
              <span>{{ viewTime(channel.viewtime) }}시간</span>
            </a>
          </swiper-slide>
        </swiper>
        <div class="arrow-back-left"></div>
        <div class="arrow-back-right"></div>
        <div :id="'swiper-button-prev-channel'" class="swiper-button-prev"></div>
        <div :id="'swiper-button-next-channel'" class="swiper-button-next"></div>
      </div>
      <div v-if="dataList.length===0" class="my-type-empty">
        <empty-list text="이용한 콘텐츠가 없어요."></empty-list>
        <a href="#" @click.prevent="moveUrl()">홈으로 이동하기</a>
      </div>
    </div>
  </section>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import EmptyList from '@/components/mypooq/EmptyList'
import _ from 'lodash'
import { PATH_NAME_HOME, PATH_NAME_PLAYER_LIVE } from '@/common/resources/router.const'
export default {
  components: {
    EmptyList,
    swiper,
    swiperSlide
  },
  props: {
    maxPage: {
      type: Number,
      default: 5
    },
    dataPerPage: {
      type: Number,
      default: 6
    },
    dataList: {
      type: Array
    }
  },
  data () {
    return {
      swiperOptions: {
        paginationClickable: true,
        spaceBetween: 10,
        slidesPerView: 6,
        slidesPerGroup: 6,
        nextButton: '#swiper-button-next-channel',
        prevButton: '#swiper-button-prev-channel',
        onTouchEnd: (swiper) => {
          this.$nextTick(() => {
            const idx = _.get(swiper, 'clickedIndex', '')
            if (idx !== '') this.moveToPlayer(this.dataList[idx].channelid)
          })
        }
      }
    }
  },
  methods: {
    viewTime (second) {
      return Math.ceil(second / 3600)
    },
    url (url) {
      return location.protocol + '//' + url
    },
    moveUrl () {
      this.$router.push({ name: PATH_NAME_HOME })
    },
    moveToPlayer (channelId) {
      this.$router.push({
        name: PATH_NAME_PLAYER_LIVE,
        query: {
          channelid: channelId
        }
      })
    }
  }
}
</script>
<style scoped>
  .arrow-back-left, .arrow-back-right {
    background: #1b1b1b;
  }
</style>
